import { useTranslation } from 'react-i18next'
import { landingAssetsForLocale } from '../config/landingAssets'

type Voice = {
  title: string
  body: string
  author: string
  avatar: string
}

function VoiceCard({ voice }: { voice: Voice }) {
  return (
    <div className='flex min-h-[240px] w-[294px] flex-shrink-0 flex-col gap-2 rounded-lg bg-white px-4 py-8 shadow-[0px_2px_10px_0px_rgba(0,0,0,0.1)]'>
      <p className='line-clamp-2 text-base font-semibold leading-[25px] tracking-[-0.41px] text-[#202020]'>
        {voice.title}
      </p>
      <div className='overflow-hidden'>
        <p className='line-clamp-4 text-sm font-light leading-[22px] tracking-[-0.24px] text-[#202020]'>
          {voice.body}
        </p>
      </div>
      <div className='mt-auto flex items-end justify-end gap-2'>
        <p className='flex-1 text-right text-xs font-light leading-[18px] text-[#8d8d8d]'>
          {voice.author}
        </p>
        <img
          src={voice.avatar}
          alt=''
          className='h-[50px] w-[50px] rounded-full border-2 border-white object-cover'
          loading='lazy'
        />
      </div>
    </div>
  )
}

export default function UserVoicesSection() {
  const { t, i18n } = useTranslation('landingPage')
  const avatars = landingAssetsForLocale(i18n.language).voiceAvatars
  const voiceItems = t('userVoices.voices', { returnObjects: true })
  const voices: Voice[] = Array.isArray(voiceItems)
    ? voiceItems.slice(0, avatars.length).map((_, index) => ({
        title: t(`userVoices.voices.${index}.title`),
        body: t(`userVoices.voices.${index}.body`),
        author: t(`userVoices.voices.${index}.author`),
        avatar: avatars[index],
      }))
    : []

  return (
    <section className='flex flex-col gap-6 bg-[#fefaf0] py-10'>
      <div className='flex flex-col gap-4 px-4'>
        <div className='flex flex-col gap-1 text-center'>
          <p className='text-[12.8px] font-semibold leading-[1.6] text-mi-on-surface-accent-secondary'>
            {t('userVoices.eyebrow')}
          </p>
          <h2 className='text-2xl font-semibold leading-[1.4] text-[#202c19]'>
            {t('userVoices.heading')}
          </h2>
        </div>
        <p className='whitespace-pre-line text-center text-base font-light leading-[1.6] text-[#202020]'>
          {t('userVoices.description')}
        </p>
      </div>

      <div className='hide-scrollbar flex items-start gap-4 overflow-x-auto px-[9px] pb-1'>
        {voices.map((voice, i) => (
          <VoiceCard key={i} voice={voice} />
        ))}
      </div>
    </section>
  )
}
